import { supabase } from "@/integrations/supabase/client";
import { agendaHasAllDayDates } from "@/lib/agendaSchema";
import { agendaRangeFilter, eventStartDate } from "@/lib/agendaDates";

export interface AgendaReadGuard { accessToken: string; assertCurrent: () => void }

export async function queryAgendaWindow(userId: string, start: Date, end: Date, countOnly = false, includeOngoing = false, guard?: AgendaReadGuard) {
  guard?.assertCurrent();
  const hasDates = await agendaHasAllDayDates();
  guard?.assertCurrent();
  let query = supabase.from("agenda_events")
    .select("*", { count: countOnly ? "exact" : undefined, head: countOnly })
    .eq("user_id", userId).is("deleted_at", null);
  const ongoing = `and(start_at.lt.${start.toISOString()},end_at.gt.${start.toISOString()})`;
  query = hasDates ? query.or(agendaRangeFilter(start, end) + (includeOngoing ? `,${ongoing}` : ""))
    : includeOngoing ? query.or(`and(start_at.gte.${start.toISOString()},start_at.lt.${end.toISOString()}),${ongoing}`)
      : query.gte("start_at", start.toISOString()).lt("start_at", end.toISOString());
  if (guard) query = query.setHeader("Authorization", `Bearer ${guard.accessToken}`);
  guard?.assertCurrent();
  const result = await query.order("start_at", { ascending: true });
  guard?.assertCurrent();
  result.data?.sort((a, b) => eventStartDate(a).getTime() - eventStartDate(b).getTime());
  return result;
}
